import {
  faChevronDown,
  faChevronUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const CollapsableCard = ({ title, subTitle, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapsed = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="collapsable-card">
      <div className={`collapsable-title ${isCollapsed ? 'collapsed' : 'expanded'}`} onClick={toggleCollapsed}>
        <div className="title-container">
          {title} <span className="font-weight-normal">{ subTitle }</span>
        </div>
        <FontAwesomeIcon
          icon={isCollapsed ? faChevronDown : faChevronUp}
          className="right mr-1 collapsable-title__icon"
        />
      </div>
      <div className={`collapsable-body ${isCollapsed ? 'collapsed' : 'expanded'}`}>
        {children}
      </div>
    </div>
  );
};

CollapsableCard.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default CollapsableCard;
